export class RcsbFvTooltip {
    showTooltip(d) {
        const tooltipDiv = document.createElement("div");
        let region = "Position: " + d.begin.toString();
        if (typeof d.end === "number" && d.end != d.begin)
            region += " - " + d.end.toString();
        const spanRegion = document.createElement("span");
        spanRegion.append(region);
        if (typeof d.value === "number") {
            const valueRegion = document.createElement("span");
            valueRegion.append(" value: " + d.value);
            tooltipDiv.append(valueRegion);
            tooltipDiv.append(RcsbFvTooltip.bNode());
        }
        tooltipDiv.append(spanRegion);
        return tooltipDiv;
    }
    showTooltipDescription(d) {
        return undefined;
    }
    static bNode() {
        const b = document.createElement("span");
        b.append(" | ");
        b.style.fontWeight = "bold";
        return b;
    }
}
